import { getRealBalanceObj, isSmartPhone } from '../../utilities/helper';
import { useSelector } from 'react-redux';
import MyProfileMWeb from './index_mWeb';
import MyProfileWeb from './index_web';

const MyProfile = () => {
  const { balanceInfo, teamName = '' } = useSelector((state: any) => state.user);
  const balance = getRealBalanceObj(balanceInfo);

  return (
    <>
      {isSmartPhone ? (
        <MyProfileMWeb balance={balance} teamName={teamName} />
      ) : (
        <MyProfileWeb balance={balance} teamName={teamName} />
      )}
    </>
  );
};

export default MyProfile;
